export default "__VITE_ASSET__ULB1jlcI__"